import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string;
  alt?: string;
};

/** Full-screen product image overlay for proposal views (customer Link B + staff preview Link A). */
export default function ProposalProductImageLightbox({ open, onOpenChange, src, alt }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton
        className={cn(
          "fixed inset-0 z-50 flex h-dvh max-h-dvh w-full max-w-[100vw] translate-x-0 translate-y-0 items-center justify-center",
          "border-0 bg-black/85 p-4 shadow-none sm:p-8",
          "[&_[data-slot=dialog-close]]:top-4 [&_[data-slot=dialog-close]]:right-4",
          "[&_[data-slot=dialog-close]]:rounded-full [&_[data-slot=dialog-close]]:bg-white/15 [&_[data-slot=dialog-close]]:p-2",
          "[&_[data-slot=dialog-close]]:text-white [&_[data-slot=dialog-close]]:opacity-100",
          "[&_[data-slot=dialog-close]]:hover:bg-white/25",
        )}
        data-testid="proposal-product-image-lightbox"
      >
        <DialogTitle className="sr-only">{alt ?? "Enlarged product image"}</DialogTitle>
        <img
          src={src}
          alt={alt ?? "Enlarged product image"}
          className="mx-auto max-h-[min(90dvh,90vh)] w-auto max-w-[min(96vw,100%)] object-contain"
          style={{ touchAction: "pan-x pan-y pinch-zoom" }}
          data-testid="proposal-product-image-lightbox-img"
        />
      </DialogContent>
    </Dialog>
  );
}
